module.exports = "<div class=\"col-md-12\">\n    <div class=\"col-md-6 split left\">\n\n    </div>\n</div>";